import request from '@/utils/request'

const getDrawInfo_web = function(code, query) {
  return request({
    url: `/v1/cp168/apis/draw/info/${code}`,
    method: 'get',
    params: query
  })
}

const getBuyPlans_web = function(query) {
  return request({
    url: '/v1/cp168/apis/recommend/jihuas',
    method: 'get',
    params: query
  })
}

export {
  getDrawInfo_web,
  getBuyPlans_web
}
